"use strict";

require("core-js/modules/es.symbol.js");

require("core-js/modules/es.symbol.description.js");

require("core-js/modules/es.symbol.iterator.js");

require("core-js/modules/es.array.from.js");

require("core-js/modules/es.function.name.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es.array.map.js");

require("core-js/modules/es.object.to-string.js");

require("core-js/modules/es.promise.js");

require("core-js/modules/es.array.iterator.js");

require("core-js/modules/es.string.iterator.js");

require("core-js/modules/web.dom-collections.iterator.js");

require("core-js/modules/es.array.concat.js");

require("core-js/modules/es.array.slice.js");

require("core-js/modules/es.array.join.js");

require("core-js/modules/es.array.filter.js");

var _merge2 = _interopRequireDefault(require("lodash/merge"));

var _uploadcareWidgetTabEffects = _interopRequireDefault(require("uploadcare-widget-tab-effects"));

var _uploadcareWidget = _interopRequireDefault(require("uploadcare-widget"));

var _analytics = require("./analytics");

var _validators = require("./validators");

var _url = require("./url");

var _constants = require("./constants");

var _copy = require("./copy");

var _thirdPartyTabStyles = _interopRequireDefault(require("./thirdPartyTabStyles"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toArray(arr) { return _arrayWithHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

// NOTE: for styles, import '@zola/zola-ui/src/styles/uploadcareWidget.less';
var PROGRESS_STATE_CLASS = 'zola-state-progress';
var ERROR_STATE_CLASS = 'zola-state-error';

var getPreviewTab = function getPreviewTab(showEffects) {
  if (showEffects) {
    // Apply effect tabs to enable photo editing in the modal
    _uploadcareWidget.default.registerTab('preview', _uploadcareWidgetTabEffects.default);

    return _uploadcareWidgetTabEffects.default;
  }

  var unwrappedUC;

  _uploadcareWidget.default.plugin(function (internalUC) {
    unwrappedUC = internalUC;
  });

  var _unwrappedUC$widget$t = unwrappedUC.widget.tabs,
      PreviewTab = _unwrappedUC$widget$t.PreviewTab,
      PreviewTabMultiple = _unwrappedUC$widget$t.PreviewTabMultiple; // The following function is based on https://github.com/uploadcare/uploadcare-widget/blob/1b33ac45986bffeb311bdb1293170b3925932aa1/src/widget/dialog.js#L215

  return function (tabPanel, tabButton, dialogApi, settings, name) {
    if (!settings.previewStep && dialogApi.fileColl.length() === 0) {
      // eslint-disable-next-line @typescript-eslint/no-empty-function
      return function () {};
    }

    var TabClass = settings.multiple ? PreviewTabMultiple : PreviewTab;
    return new TabClass(tabPanel, tabButton, dialogApi, settings, name);
  };
}; // Listens for changes to Uploadcare's file collection and adds an error or progress class
// to the dialog element as needed (depending on the files' status).


var handleWidgetState = function handleWidgetState(dialogElement, fileColl, maxFileCount) {
  // eslint-disable-next-line no-underscore-dangle
  var widgetFiles = fileColl.__items;

  var updateWidgetState = function updateWidgetState() {
    var anyFilesInProgress = widgetFiles.some(function (file) {
      return file.state() === 'pending';
    });
    var anyFilesFailed = widgetFiles.some(function (file) {
      return file.state() === 'rejected';
    });

    if (anyFilesInProgress) {
      dialogElement.addClass(PROGRESS_STATE_CLASS);
      dialogElement.removeClass(ERROR_STATE_CLASS);
    } else if (anyFilesFailed) {
      dialogElement.removeClass(PROGRESS_STATE_CLASS);
      dialogElement.addClass(ERROR_STATE_CLASS);
    } else {
      dialogElement.removeClass(PROGRESS_STATE_CLASS);
      dialogElement.removeClass(ERROR_STATE_CLASS);
    }
  }; // User added a new file


  fileColl.onAdd.add(function (file) {
    // Immediately cancel the upload if over maxFileCount (to save time and bandwidth)
    if (maxFileCount && widgetFiles.length > maxFileCount) file.cancel(); // When an upload starts, update the widget state

    updateWidgetState(); // When an upload completes (success or failure), update the widget state

    file.always(updateWidgetState);
  }); // User clicked file's trash icon

  fileColl.onRemove.add(function (file) {
    // When a pending file is removed from the list, force the upload to cancel (to save time and bandwidth)
    if (file.state() === 'pending') file.cancel(); // When a file is removed, update the widget state

    file.always(updateWidgetState);
  });
};

var openUploadcareModal = function openUploadcareModal(_ref) {
  var _ref$inputAcceptTypes = _ref.inputAcceptTypes,
      inputAcceptTypes = _ref$inputAcceptTypes === void 0 ? _constants.DEFAULT_FILE_TYPES : _ref$inputAcceptTypes,
      _ref$closeViaOverlay = _ref.closeViaOverlay,
      closeViaOverlay = _ref$closeViaOverlay === void 0 ? true : _ref$closeViaOverlay,
      cropRatio = _ref.cropRatio,
      imageShrink = _ref.imageShrink,
      _ref$maxFileCount = _ref.maxFileCount,
      maxFileCount = _ref$maxFileCount === void 0 ? 0 : _ref$maxFileCount,
      _ref$maxSize = _ref.maxSize,
      maxSize = _ref$maxSize === void 0 ? _constants.DEFAULT_MAX_FILE_SIZE_MB : _ref$maxSize,
      multipartMinSize = _ref.multipartMinSize,
      _ref$minFileCount = _ref.minFileCount,
      minFileCount = _ref$minFileCount === void 0 ? 1 : _ref$minFileCount,
      minDimension = _ref.minDimension,
      minHeight = _ref.minHeight,
      minWidth = _ref.minWidth,
      onAddPhotos = _ref.onAddPhotos,
      onUploadcareFileReady = _ref.onUploadcareFileReady,
      _ref$showEffects = _ref.showEffects,
      showEffects = _ref$showEffects === void 0 ? true : _ref$showEffects,
      value = _ref.value,
      analyticsProduct = _ref.analyticsProduct,
      analyticsLocation = _ref.analyticsLocation,
      _ref$tabs = _ref.tabs,
      tabs = _ref$tabs === void 0 ? _constants.DEFAULT_TABS : _ref$tabs,
      effects = _ref.effects;
  var isMultiple = minFileCount > 1 || maxFileCount > 1; // TODO: Restore analytics

  var _getUploadAnalytics = (0, _analytics.getUploadAnalytics)(analyticsProduct, analyticsLocation),
      startAnalytics = _getUploadAnalytics.startAnalytics,
      stopAnalytics = _getUploadAnalytics.stopAnalytics;

  var handleFileSelect = function handleFileSelect(file) {
    // If the cached image was deleted, ignore the change.
    if (!file) return;
    if (onAddPhotos) onAddPhotos(); // eslint-disable-next-line @typescript-eslint/no-floating-promises

    file.done(function (completedFile) {
      // Don't invoke callback if nothing changed
      var newUrl = (0, _url.stripUploadcareUrlPatches)(completedFile.cdnUrl);
      var valueisIdentical = value && newUrl === value[0];
      if (valueisIdentical) return;
      onUploadcareFileReady((0, _url.patchUploadcareFileUrls)(completedFile));
    });
  };

  var handleFileGroupSelect = function handleFileGroupSelect(fileGroup) {
    // If all cached images were deleted, ignore the change.
    if (!fileGroup) return;
    if (onAddPhotos) onAddPhotos();
    var filePromises = fileGroup.files().map(function (file) {
      return new Promise(function (resolve) {
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        file.done(function (completedFile) {
          return resolve(completedFile);
        });
      });
    });
    Promise.all([fileGroup.promise()].concat(_toConsumableArray(filePromises))).then(function (_ref2) {
      var _ref3 = _toArray(_ref2),
          completedGroup = _ref3[0],
          completedFiles = _ref3.slice(1);

      var newUrls = completedFiles.map(function (f) {
        return (0, _url.stripUploadcareUrlPatches)(f.cdnUrl);
      });
      var valuesAreIdentical = value && newUrls.every(function (newUrl, i) {
        return newUrl === value[i];
      }); // Only invoke callback if images or image order change.

      if (valuesAreIdentical) return;
      var patchedFiles = completedFiles.map(_url.patchUploadcareFileUrls);
      onUploadcareFileReady(completedGroup.uuid, patchedFiles);
    }).catch(function () {
      return new Error('Problem uploading uploadcare files');
    });
  };

  var validators = [(0, _validators.validateMinDimensions)(minWidth, minHeight, minDimension), (0, _validators.validateMaxFileSize)(maxSize), (0, _validators.validateFileType)(inputAcceptTypes)];
  var settings = {
    crop: cropRatio,
    customTabs: {
      preview: getPreviewTab(showEffects)
    },
    effects: effects || "".concat(cropRatio ? 'crop,' : '', "mirror,enhance,sharp,blur,grayscale"),
    imagesOnly: true,
    imageShrink: imageShrink,
    multiple: isMultiple,
    multipleMin: minFileCount,
    multipleMax: maxFileCount,
    multipartMinSize: multipartMinSize,
    publicKey: _constants.PUBLIC_KEY,
    inputAcceptTypes: inputAcceptTypes.join(','),
    preloader: null,
    previewStep: true,
    tabs: tabs,
    validators: validators
  }; // Apply our custom styles to 3rd party tabs (e.g. Facebook, Dropbox)

  _uploadcareWidget.default.tabsCss.addStyle(_thirdPartyTabStyles.default); // Make sure the dialog copy contains the current widget's settings


  _uploadcareWidget.default.plugin(function (internal) {
    var filledOutCopy = (0, _copy.getWidgetCopy)({
      minDimension: minDimension,
      minWidth: minWidth,
      minHeight: minHeight,
      maxSize: maxSize,
      maxFileCount: maxFileCount,
      inputAcceptTypes: inputAcceptTypes
    }); // eslint-disable-next-line no-param-reassign

    internal.locale.translations.en = (0, _merge2.default)(internal.locale.translations.en, filledOutCopy);
    internal.locale.rebuild();
  }); // Open the actual modal


  var _uploadcare$openDialo = _uploadcareWidget.default.openDialog(null, settings),
      dialogElement = _uploadcare$openDialo.dialogElement,
      fileColl = _uploadcare$openDialo.fileColl,
      always = _uploadcare$openDialo.always,
      addFiles = _uploadcare$openDialo.addFiles,
      switchTab = _uploadcare$openDialo.switchTab,
      done = _uploadcare$openDialo.done; // Listen to file changes and apply the "error" or "in progress" classes to the widget modal as needed


  handleWidgetState(dialogElement, fileColl, maxFileCount); // Stop mousedown events from propagating outside of the dialog

  dialogElement.bind('mousedown', function (e) {
    e.stopPropagation();
  }); // Sometimes, we want to make sure clients don't accidentally close the widget.

  if (!closeViaOverlay) {
    dialogElement.off('dblclick');
  } // Track file errors and successful uploads


  startAnalytics(fileColl); // When the dialog is closed and valid files are selected, invoke the callback

  done(isMultiple ? handleFileGroupSelect : handleFileSelect); // When the dialog is closed, make sure the analytics are stopped

  always(function () {
    stopAnalytics();
  }); // If any existing files were provided, we need to add them to the dialog AFTER it's open.
  // This is because using uploadcare.filesFrom BEFORE the dialog creates a fileColl means that
  // fileColl.onAdd is never triggered, which breaks our progress / error detection in handleWidgetState.

  if (value) {
    var files;

    if (value instanceof FileList) {
      files = _uploadcareWidget.default.filesFrom('object', value, settings);
    } else {
      var urls = Array.isArray(value) ? value : [value]; // If value isn't already an array, create one

      var validUrls = urls.filter(function (url) {
        return !!url;
      });
      var strippedUrls = validUrls.map(_url.stripUploadcareUrlPatches); // Makes sure that the input and output URLs are formatted the same.

      files = strippedUrls.length ? strippedUrls : null;
    }

    addFiles(files);
    switchTab('preview');
  }
};

var _default = openUploadcareModal;
exports.default = _default;